import { render, staticRenderFns } from "./sceneEdit.vue?vue&type=template&id=3a195721&scoped=true"
import script from "./sceneEdit.vue?vue&type=script&lang=js"
export * from "./sceneEdit.vue?vue&type=script&lang=js"
import style0 from "./sceneEdit.vue?vue&type=style&index=0&id=3a195721&prod&lang=css"
import style1 from "./sceneEdit.vue?vue&type=style&index=1&id=3a195721&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a195721",
  null
  
)

export default component.exports